import { render } from "./AssessmentIssuesDisplay.vue?vue&type=template&id=2f083892&scoped=true"
import script from "./AssessmentIssuesDisplay.vue?vue&type=script&lang=js"
export * from "./AssessmentIssuesDisplay.vue?vue&type=script&lang=js"

import "./AssessmentIssuesDisplay.vue?vue&type=style&index=0&id=2f083892&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f083892"]])

export default __exports__